//import {START_LOADING,END_LOADING,SHOW_ATMODAL,HIDE_ATMODAL} from '../constants/ActionTypes'

import * as types from '../constants/ActionTypes'
const objectAssign = require('object-assign');

const initialState = {
    list: [], //列表
    count: 0,
    maxPage: 0,
    params: { 
        current: 1,
        pageSize: 15,
        topN: 0,
        searchValue: "",
        type: "3",
        typeName: "更新日期",
        module:"",
        moduleName: "",
        ind:"",
        indName:""
    }, //参数
    typeDatas:[
        {label: "更新日期",value: "3"},
        {label: "发布日期",value: "2"},
        {label: "应用热度",value: "1"}
    ], //排序
    moduleDatas:[], //类别
    indDatas:[], //行业
    openFliter:"", //当前打开的下拉
    pageLoading:false,
    scrollTop: 0,
    height: 0
};

export default function apps(state = initialState, action) {
    switch (action.type) {
    	case types.RESET_SCROLLTOP:
    		return objectAssign({}, state,{scrollTop:action.data});
    	case types.RESET_HEIGHT:
    		return objectAssign({}, state,{height:action.data});
    	case types.RESET_PARAMS:
    		return objectAssign({}, state,{params:initialState.params});
        case types.GET_APPS:
        	const newApps = objectAssign({}, state,
            	!!sessionStorage.csmApps ? JSON.parse(sessionStorage.csmApps) :
            	{list:action.nextPage?state.list.concat(action.list):action.list,count:action.count,maxPage:Math.ceil(action.count/state.params.pageSize)}
            );
            sessionStorage.removeItem('csmApps');
            return newApps
        case types.SET_MENU:
            return objectAssign({}, state,{openFliter:action.openFliter});
        case types.GET_MODULE:
            return objectAssign({}, state,function(){
                //console.log("action:",action);
                let datas = action.moduleDatas || [];
                datas = datas.map((data)=>{
                    let newData = {
                        label:data.g_name,
                        value:data.g_id
                    }
                    return newData;
                });
                datas = [{label:"所有类型",value:""}].concat(datas);
                return {moduleDatas:datas}
            }());
        case types.GET_IND:
            return objectAssign({}, state,function(){
                //console.log("action:",action);
                let datas = action.indDatas || [];
                datas = datas.map((data)=>{
                    let newData = {
                        label:data.g_name,
                        value:data.g_id
                    }
                    return newData;
                });
                datas = [{label:"所有行业",value:""}].concat(datas);
                return {indDatas:datas}
            }());
        case types.DO_FLITER:
           	return objectAssign({}, state, {params:objectAssign({},state.params,action.params)});
        case types.GO_PAGE:
            return objectAssign({}, state, {params:objectAssign({},state.params,{current:action.current})});
        case types.PAGE_LOADING:
          return Object.assign({}, state, {pageLoading:action.pageLoading});
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./project/reducers/apps.js